import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getProduct } from 'api/requests';

export const fetchProduct = createAsyncThunk('product/fetchProduct', async (product) => {
    try {
        const response = await getProduct(product);
        return response.data;
    } catch (error) {
        throw error;
    }
});

const productSlice = createSlice({
    name: 'product',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchProduct.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProduct.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchProduct.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default productSlice.reducer;